import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-28 px-6 bg-darker text-center" data-id="element-125">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="max-w-[600px] mx-auto bg-gradient-to-br from-[rgba(0,210,106,0.08)] to-[rgba(0,210,106,0.03)] border-2 border-[rgba(0,210,106,0.3)] rounded-[24px] p-10 md:p-12" data-id="element-126">
        <span className="text-[64px] block mb-6" data-id="element-127">🛡️</span>
        <h2 className="text-[32px] font-black mb-4 text-green" data-id="element-128">
          Mi Promesa Para Ti
        </h2>
        <p className="text-[16px] text-[#CCCCCC] leading-[1.8]" data-id="element-129">
          Si implementas el Workflow de 4 Horas y no tienes 30 piezas de
          contenido listas, escríbeme directamente y lo resolvemos juntos. Este
          sistema funciona porque está construido sobre principios probados — no
          sobre modas de redes sociales.
          <br data-id="element-130" />
          <br data-id="element-131" />
          <strong className="text-white" data-id="element-132">
            Si lo aplicas, funciona. Así de simple.
          </strong>
        </p>
      </motion.div>
    </section>;
}